module.exports = __webpack_public_path__ + "img/faster@3x.4337301d.png";